/*
 * Month and year only on review dates rendered by the Air Reviews app.
 *
 * WHY THIS EXISTS
 * Review dates should read "August 2026", not "08/26/2026". On /pages/reviews
 * the cards are ours and the format is set directly in civia-reviews-grid.js.
 * Everywhere else - the homepage carousel and the review list on every product
 * page - the markup belongs to the Air Reviews app, which prints MM/DD/YYYY
 * into .AirReviews-Blocks__Date and offers no theme-side setting for it.
 *
 * The proper place to change this is the app's own settings. This is the
 * theme-side alternative, and it is written to fail quietly: if the app ever
 * changes its class name or its date format, nothing matches, nothing is
 * rewritten, and the shopper keeps seeing the app's own date. A date in the
 * wrong format is a much smaller problem than a blank one.
 *
 * ON THE DAY BEING DROPPED
 * Only the display changes. Sorting, the review data and the app's own
 * behaviour all still use the real timestamp - nothing here touches it.
 */

(function () {
  'use strict';

  var SELECTOR = '.AirReviews-Blocks__Date';

  /* Only used if toLocaleDateString throws, which it should not. */
  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function format(year, month) {
    try {
      /* Same call the reviews grid makes, so both surfaces read identically
         and both follow the shopper's locale. */
      return new Date(year, month - 1, 1).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long'
      });
    } catch (e) {
      return MONTHS[month - 1] + ' ' + year;
    }
  }

  /* The app prints MM/DD/YYYY - confirmed against the data behind it, where a
     review with createdAt 2026-08-26 renders as "08/26/2026". Both orders are
     handled anyway: whichever of the two leading numbers is above 12 can only
     be a day, and when neither is, the app's own MM/DD order is assumed.
     Anything that is not a plain numeric date is left alone. */
  function monthYear(text) {
    var parts = String(text).trim().match(/^(\d{1,4})[\/\-.](\d{1,4})[\/\-.](\d{1,4})$/);
    if (!parts) return null;

    var first = parseInt(parts[1], 10);
    var second = parseInt(parts[2], 10);
    var third = parseInt(parts[3], 10);
    var year;
    var month;

    if (parts[3].length === 4) {
      year = third;
      month = first > 12 ? second : first;
    } else if (parts[1].length === 4) {
      year = first;
      month = second;
    } else {
      return null;
    }

    if (!(month >= 1 && month <= 12)) return null;
    if (!(year >= 1970 && year <= 9999)) return null;

    return format(year, month);
  }

  /* Idempotent by construction: once a node reads "August 2026" the numeric
     pattern no longer matches, so a second pass leaves it alone. That is also
     what stops the observer below from looping on its own writes. */
  function apply() {
    var nodes = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < nodes.length; i++) {
      var replacement = monthYear(nodes[i].textContent);
      if (replacement) nodes[i].textContent = replacement;
    }
  }

  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;

    window.setTimeout(function () {
      scheduled = false;
      apply();
    }, 60);
  }

  function start() {
    apply();

    /* The app renders asynchronously and re-renders on pagination, so a single
       pass at load is not enough. The observer callback only sets a flag; the
       actual work is debounced to at most one querySelectorAll every 60ms. */
    if (!window.MutationObserver || !document.body) return;

    new window.MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
